export default {
  setProduces(context, vegTypes){
    context.commit("setProduces", vegTypes);
  }
}